import { useCallback, useEffect, useState } from 'react';
import { useAppInit } from '../contexts/appInitContext';
import { useApi } from './useApi';

export interface IreturnReason {
  code: string;
  description: string;
  canUploadPhoto: boolean;
  requiresPhoto: boolean;
  isClaim: boolean;
}
export interface IreturnReasonsResponse {
  reasons: IreturnReason[];
}

export interface Ioption {
  value: string | number;
  label: string;
  canUploadPhoto: boolean;
  requiresPhoto: boolean;
  isClaim: boolean;
}

const getOptionsFromReturnReasons = (data: IreturnReason[]): Ioption[] =>
  data.map((item) => ({
    value: item.code,
    label: item.description,
    canUploadPhoto: item.canUploadPhoto,
    requiresPhoto: item.requiresPhoto,
    isClaim: item.isClaim,
  }));

export const useReturnReasons = (productNo: string) => {
  const api = useApi();

  const {
    params,
  } = useAppInit();

  const [reasons, setReturnReasons] = useState<Ioption[]>([]);
  const [loading, setLoading] = useState(true);

  const getReturnReasons = useCallback(async () => {
    const response = await api(
      `returnreasons?iso6391=${params.languageCode ?? ''}&productNumber=${productNo}&returnType=${params.returnType ?? ''}`,
      'GET',
      '*',
    );
    setLoading(false);
    setReturnReasons(getOptionsFromReturnReasons(response.data.reasons));
  }, [api, productNo, params]);

  useEffect(() => {
    getReturnReasons();
  }, [getReturnReasons]);

  return { reasons, loading };
};
